import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type SingleChatState = {
  hash_id: string;
  channel_hash_id: string;
  messages: any[];
  newlyAddedChats: any[];
  showRedLine: boolean;
};

export type chatsState = {
  [hash_id: string]: any;
};

const initialState: chatsState = {};

const chatsSlice = createSlice({
  name: 'chats',
  initialState,
  reducers: {
    handleChatList(
      state,
      action: PayloadAction<{
        hash_id: string;
        channel_hash_id: string;
        messages: any[];
      }>
    ) {
      const { hash_id, channel_hash_id, messages } = action.payload;
      // Clear previous chat
      for (const key in state) {
        delete state[key];
      }
      // Set new chat by hash_id
      state[hash_id] = {
        hash_id,
        channel_hash_id,
        messages,
        newlyAddedChats: [],
        showRedLine: true
      };
    },

    addNewChat(
      state,
      action: PayloadAction<{
        hash_id: string;
        comment: Comment;
        showNewlyAdded: boolean;
      }>
    ) {
      const chat = state[action.payload.hash_id];
      if (!chat) return;

      chat.messages.push(action.payload.comment);

      if (action.payload.showNewlyAdded) {
        if (chat.showRedLine) {
          chat.newlyAddedChats.push(action.payload.comment);
        } else {
          chat.newlyAddedChats = [];
        }
      }
    },

    setShowRedline(state, action: PayloadAction<{ hash_id: string; show: boolean }>) {
      const chat = state[action.payload.hash_id];
      if (chat) {
        chat.showRedLine = action.payload.show;
      }
    },
    editChat(
      state,
      action: PayloadAction<{
        videoHashId: string;
        hashId: string;
        updatedContent: string;
      }>
    ) {
      const chat = state[action.payload.videoHashId];
      if (!chat) return;
      const msgIndex = chat.messages.findIndex((msg: any) => msg.hash_id === action.payload.hashId);
      if (msgIndex !== -1) {
        const message = chat.messages[msgIndex];
        if (message) {
          chat.messages[msgIndex].content = action.payload.updatedContent;
        }
      }
    },
    deleteChatComment(
      state,
      action: PayloadAction<{
        hash_id: string;
        commentId: string;
      }>
    ) {
      const chat = state[action.payload.hash_id];
      if (!chat) return;

      chat.messages = chat.messages.filter((msg: any) => msg.hash_id !== action.payload.commentId);
      chat.newlyAddedChats = chat.newlyAddedChats.filter((msg: any) => msg.hash_id !== action.payload.commentId);
    }
  }
});

export const { handleChatList, addNewChat, setShowRedline, editChat, deleteChatComment } = chatsSlice.actions;
export const chatsReducer = chatsSlice.reducer;
